import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import frLocale from 'i18n-iso-countries/langs/fr.json';

import { language } from '@/ui/i18n';

countries.registerLocale(frLocale);
countries.registerLocale(enLocale);

export function getAllCountryNames() {
  const countryNames = countries.getNames(language);
  return countryNames;
}
